import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV, COMPANY } from "../../data/site";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 border-b ${
        scrolled
          ? "bg-[#FAF6EE]/90 backdrop-blur-xl border-black/10"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          data-testid="header-logo"
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-3 group"
        >
          <img
            src="/brand/mbprism-logo.png"
            alt="MB Prism Software Solutions Ltd."
            className="h-9 md:h-11 w-auto group-hover:opacity-80 transition-opacity"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => scrollTo(n.id)}
              className="text-sm tracking-wide text-[#0A0A0A] hover:text-[#2F6B1F] transition-colors duration-200"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <span className="font-mono-ibm text-xs text-[#404040]">
            {COMPANY.phone}
          </span>
          <button
            data-testid="header-cta-contact"
            onClick={() => scrollTo("contact")}
            className="bg-[#2F6B1F] text-white px-5 py-2.5 text-sm font-medium hover:bg-[#FF331F] transition-colors duration-300"
          >
            Start a project →
          </button>
        </div>

        <button
          data-testid="header-mobile-menu-toggle"
          className="lg:hidden p-2 -mr-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#FAF6EE] border-t border-black/10"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => scrollTo(n.id)}
                className="text-left text-lg font-display tracking-tight"
              >
                {n.label}
              </button>
            ))}
            <button
              data-testid="mobile-cta-contact"
              onClick={() => scrollTo("contact")}
              className="bg-[#2F6B1F] text-white px-5 py-3 text-sm font-medium w-full"
            >
              Start a project →
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
